import { Form } from 'formik';
import { makeStyles, Theme, useTheme, Card, Button, CircularProgress } from '@material-ui/core';
import { Save as SaveIcon } from '@material-ui/icons';
import GeneralInfo from './GeneralInfo';
import Contacts from './Contacts';
import Address from './Address';
import DealerType from './DealerType';
import { useLocation } from 'react-router-dom';


let useStyles = makeStyles((theme: Theme) => ({
    card: {
        marginTop: 16
    },
    button: {
        marginTop: 16,
        marginBottom: 16,
        float: "right"
    }
}));

interface IProps {
    isSaving: boolean
    form: any
}

let DealerDetailForm = (props: IProps) => {
    let theme = useTheme();
    let classes = useStyles(theme);

    let location = useLocation();

    let isNew = location.pathname.includes("/edit");


    return (
        <Form>
            <Card className={classes.card}>
                <GeneralInfo form={props.form} />
            </Card>

            <Card className={classes.card}>
                <Contacts />
            </Card>

            <Card className={classes.card}>
                <Address />
            </Card>

            {isNew === true &&
                <Card className={classes.card}>
                    <DealerType />
                </Card>
            }

            <Button
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={props.isSaving}
                type="submit"
            >
                <SaveIcon /> Save
                {props.isSaving && <>&nbsp;<CircularProgress size={20} /></>}
            </Button>
        </Form>
    );
}


export default DealerDetailForm;
